<div
    class="pacing-container"
    [ngClass]="layout"
    *ngIf="showContent"
    [pTooltip]="pacingTooltip"
    tooltipStyleClass="wide-tooltip"
    tooltipPosition="bottom"
    [class.copyable]="canCopy"
    [attr.role]="canCopy ? 'button' : null"
    [attr.tabindex]="canCopy ? 0 : null"
    [attr.title]="canCopy ? 'Copy pacing breakdown to clipboard (Google Sheets)' : null"
    (click)="copyPacingToClipboard()"
    (keydown.Enter)="copyPacingToClipboard()"
    (keydown.Space)="$event.preventDefault(); copyPacingToClipboard()"
>
    <div class="pacing-section">
        <!-- Card Layout -->
        <ng-container *ngIf="layout === 'card'">
            <div
                class="pacing-row main"
                *ngIf="pacing?.pacingRevenue !== actualRevenue"
            >
                <span class="pacing-val">
                    {{ (pacing?.pacingRevenue || 0) / 100 | currency:undefined:undefined:'1.0-0' }}
                </span>
            </div>
            <div class="pacing-row compact-metrics">
                <span
                    title="Performance vs LY"
                    [class.positive]="(pacing?.performanceToday ?? 1) >= 1"
                    [class.negative]="(pacing?.performanceToday ?? 1) < 1"
                    *ngIf="pacing?.performanceToday !== null && pacing?.performanceToday !== undefined"
                >
                    {{ (pacing?.performanceToday ?? 1) | percent:'1.0-0' }} vs LY
                </span>
            </div>
        </ng-container>

        <!-- Strip Layout -->
        <ng-container *ngIf="layout === 'strip'">
            <span class="pacing-label">Pacing</span>
            <div class="pacing-metrics">
                <span title="Projected Month-End Revenue">{{ (pacing?.pacingRevenue || 0) / 100 |
                    currency:undefined:undefined:'1.0-0' }}</span>
                <span class="separator">|</span>
                <span
                    title="Performance vs Last Year"
                    [class.positive]="(pacing?.performanceToday ?? 1) >= 1"
                    [class.negative]="(pacing?.performanceToday ?? 1) < 1"
                    *ngIf="pacing?.performanceToday !== null && pacing?.performanceToday !== undefined"
                >
                    {{ (pacing?.performanceToday ?? 1) | percent:'1.0-0' }}
                </span>
            </div>
            <!-- No copy icon (Ray): the whole box copies (the container's
                 own click); the affordance is the pointer cursor + hover.
                 No aria-label on the box: its accessible name must stay the
                 DISPLAYED values (CodeRabbit) — the sr-only span adds the
                 copy instruction to that name instead of masking it. -->
            <span class="p-sr-only" *ngIf="canCopy">Copy pacing breakdown to clipboard</span>
        </ng-container>
    </div>
</div>

<ng-template #pacingTooltip>
    <div class="pacing-tooltip-content">
        <div class="tooltip-header">Pacing vs Last Year</div>
        <ng-container *ngIf="hasBaseline; else noBaseline">
            <div class="tooltip-math">
                <div class="math-row">
                    <strong>Performance</strong>
                    <span>= Current ÷ <span [ngClass]="baselineClass">{{ baselineLabel }}</span></span>
                </div>
                <div class="math-row">
                    <span></span>
                    <span>= {{ actualRevenue / 100 | currency:undefined:undefined:'1.0-0' }}
                        ÷ <span [ngClass]="baselineClass">{{ baseline / 100 | currency:undefined:undefined:'1.0-0' }}</span>
                        = <span
                            [class.positive]="(pacing?.performanceToday ?? 1) >= 1"
                            [class.negative]="(pacing?.performanceToday ?? 1) < 1"
                        >{{ (pacing?.performanceToday ?? 0) | percent:'1.0-0' }}</span>
                    </span>
                </div>
                <div class="math-row">
                    <strong>Projected</strong>
                    <span>= Performance × <span class="ly-final">LY Final</span></span>
                </div>
                <div class="math-row">
                    <span></span>
                    <span>= {{ (pacing?.performanceToday ?? 0) | percent:'1.0-0' }}
                        × <span class="ly-final">{{ (pacing?.lastYearRevenueFinal || 0) / 100 | currency:undefined:undefined:'1.0-0' }}</span>
                        = <strong>{{ (pacing?.pacingRevenue || 0) / 100 | currency:undefined:undefined:'1.0-0' }}</strong>
                    </span>
                </div>
            </div>
        </ng-container>
        <ng-template #noBaseline>
            <div class="tooltip-row">
                <strong>Projected:</strong>
                <span>{{ (pacing?.pacingRevenue || 0) / 100 | currency:undefined:undefined:'1.0-0' }} (no last-year revenue to compare)</span>
            </div>
        </ng-template>
        <div class="tooltip-legend">
            <div>
                <span class="ly-today">LY Today</span>: what was booked for {{ lyDayLabel }}
                by this time last year
            </div>
            <div>
                <span class="ly-final">LY Final</span>: what {{ lyDayLabel }} finished at
            </div>
        </div>
    </div>
</ng-template>
